export const SvgGoldBadge = () => {
	return (
		<svg
			width="18"
			height="24"
			viewBox="0 0 18 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.57161 0C3.83758 0 0 3.83758 0 8.57161C0 13.3054 3.83758 17.1432 8.57161 17.1432C13.3056 17.1432 17.1432 13.3054 17.1432 8.57161C17.1432 3.83758 13.3056 0 8.57161 0ZM8.57161 2.28581C12.0433 2.28581 14.8575 5.09996 14.8575 8.57166C14.8575 12.0431 12.0433 14.8575 8.57161 14.8575C5.09991 14.8575 2.28576 12.0432 2.28576 8.57166C2.28576 5.10001 5.09991 2.28581 8.57161 2.28581ZM8.57161 4.28581L7.19663 6.85719L4.28581 7.3393L6.3484 9.4198L5.9197 12.286L8.57165 11.0001L11.2236 12.286L10.7949 9.4198L12.8575 7.3393L9.94666 6.85719L8.57161 4.28581ZM2.57148 15.8304V24L8.57161 19.7142L14.5717 24V15.8304C12.9397 17.1817 10.8498 18.0002 8.57161 18.0002C6.29345 18.0002 4.20351 17.1817 2.57148 15.8304Z"
				fill="#9F7500"
			/>
		</svg>
	);
};
